<template>
  <div style="height:100%">
    <iframe :src="weburl" frameborder="0" style="height:100%;width:100%"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      weburl: "",
    };
  },
  mounted() {
    this.weburl = this.$route.query.url;
  },

  watch: {
    "$route.query.url"(val) {
      this.weburl = this.$route.query.url;
    },
  },
};
</script>
